import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { SubprefeituraState } from './state';

const defaultState: SubprefeituraState = {
  subprefeituras: [],
};

export const subprefeituraModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
